import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ProviderSurgeIncentive from './provider-surge-incentive';
import { providerSurgeIncentiveSearchRequest } from '../actions';

export class ProviderSurgeIncentiveContainer extends Component {
  componentDidMount() {
    this.props.fetchIncentives();
  }

  componentWillUnmount() {
    if (this.props.incentivesLoading) {
      this.props.cancelFetchIncentives();
    }
  }

  render() {
    const { flashMessage } = this.props;

    return <ProviderSurgeIncentive flashMessage={flashMessage} />;
  }
}

ProviderSurgeIncentiveContainer.propTypes = {
  incentivesLoading: PropTypes.bool.isRequired,
  fetchIncentives: PropTypes.func.isRequired,
  cancelFetchIncentives: PropTypes.func.isRequired,
  flashMessage: PropTypes.string
};

const mapStateToProps = state => ({
  incentivesLoading: state.providerSurgeIncentive.searchRequest.isLoading,
  flashMessage: state.providerSurgeIncentive.flashMessage.message
});

const mapDispatchToProps = {
  fetchIncentives: providerSurgeIncentiveSearchRequest.start,
  cancelFetchIncentives: providerSurgeIncentiveSearchRequest.cancel
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderSurgeIncentiveContainer);
